import React from 'react';
import { Link } from 'react-router-dom';
import APP from 'app';
const { showFlightMobile = true, showHotelMobile = true } = APP.Utils.getConfig();

const ProductList = (props) => {
    const { fixedHeader = false } = props;
    const fixedClass = fixedHeader ? 'fixed' : '';
    return (
        <div className={`productList ${fixedClass}`}>
            {showFlightMobile &&
                <div class="productList__item">
                    <Link to='/flight/' className="productList__link">
                        <i class="fas fa-plane productList__icon"></i>
                        <h5 class="productList__text">Flight</h5>
                    </Link>
                </div>}
            {showHotelMobile &&
                <div class="productList__item">
                    <a href="/hotel/" className="productList__link">
                        <i class="fas fa-building productList__icon"></i>
                        <h5 class="productList__text">Hotel</h5>
                    </a>
                </div>}
        </div>
    )
}

export default ProductList
